var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDocumentacao = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M18 9H15.6716H14C13.45 9 13 8.55 13 8V6.32843V4.00007L6 4V20H18V9ZM13.17 2C13.7 2 14.21 2.21 14.59 2.59L19.41 7.42C19.79 7.79 20 8.3 20 8.83V20C20 21.1 19.1 22 18 22H5.99C4.89 22 4 21.1 4 20V4C4 2.9 4.9 2 6 2H13.17ZM15 18H9C8.45 18 8 17.55 8 17C8 16.45 8.45 16 9 16H15C15.55 16 16 16.45 16 17C16 17.55 15.55 18 15 18ZM9 14H15C15.55 14 16 13.55 16 13C16 12.45 15.55 12 15 12H9C8.45 12 8 12.45 8 13C8 13.55 8.45 14 9 14Z",
  fill: "#FF8B22"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgDocumentacao);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/documentacao.78e25c96f4e6ea10aaa741651bf6ab7c.svg";